import { createContext, useContext } from 'react';
import { UserDataType } from './UserData';

export type AuthStatus = 'loading' | 'anonymous' | 'authenticated' | 'error';

export type AuthProfile = Partial<UserDataType> & {
  email?: string | null;
  display_name?: string | null;
  auth_provider?: 'email' | 'google' | 'telegram' | string | null;
};

export type AuthContextType = {
  authStatus: AuthStatus;
  authUser: AuthProfile | null;
  authError: string | null;
  isProfileSaving: boolean;
  requestEmailMagicLink: (email: string) => Promise<void>;
  completeMagicLink: (token: string) => Promise<void>;
  startGoogleLogin: () => void;
  loginWithTelegramWidget: (telegramPayload: Record<string, unknown>) => Promise<void>;
  loginWithTelegramMiniApp: (initData: string) => Promise<void>;
  saveProfile: (profile: AuthProfile) => Promise<void>;
  logout: () => Promise<void>;
  refreshAuthSession: () => Promise<void>;
};

const AuthContext = createContext<AuthContextType | null>(null);

export const useAuthData = () => useContext(AuthContext);

export default AuthContext;
